import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import RequesterProfile from './RequesterProfile';
import { Container, ContentContainer, Content, Logo, HeaderSection } from './styles';

const DesktopHeader = () => {
  const accountResult = useSelector((state: RootState) => state.user.accountResult);

  const fullName = useMemo(() => `${accountResult?.name || ''} ${accountResult?.lastName || ''}`, [accountResult]);
  const email = useMemo(() => accountResult?.email || '', [accountResult]);
  const companyName = useMemo(() => accountResult?.companyName || '', [accountResult]);
  const companyCountry = useMemo(() => accountResult?.countryName || '', [accountResult]);
  const companyCountryCode = useMemo(() => accountResult?.countryId || '', [accountResult]);
  const hasCompanyBranches = useMemo(() => accountResult?.hasBranchCompanies || false, [accountResult]);
  const branchCompanyLogged = useMemo(() => accountResult?.branchCompanyLogged || false, [accountResult]);

  return (
    <Container>
      <ContentContainer>
        <Content>
          <Logo src="/images/logo-rappi-travel4business.svg" />

          <HeaderSection>
            <RequesterProfile
              name={fullName}
              email={email}
              companyName={companyName}
              companyCountry={companyCountry}
              branchCompanyLogged={branchCompanyLogged}
              hasCompanyBranches={hasCompanyBranches}
              companyCountryCode={companyCountryCode}
            />
          </HeaderSection>
        </Content>
      </ContentContainer>
    </Container>
  );
};

export default DesktopHeader;
